// src/components/Card.tsx
import React from 'react';

type CardProps = {
  children: React.ReactNode;
  className?: string;
};

const Card: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <div className={`bg-newsprint-panel border border-rule rounded-sm p-6 ${className}`}>
      {children}
    </div>
  );
};

export default Card;